import { ShowSave } from "../../models/ShowSave";
import { Action } from "../../models/Action";
import { SHOW_TYPES } from "./showTypes";
import loadingReducer from "../loadingReducer";
import { getShowsList } from "./showActions";

export interface ShowState {
  loading: boolean;
  shows: ShowSave[];
}

const initialShow: ShowState = {
  loading: false,
  shows: [],
};

export default function showReducer(showState = initialShow, action: Action<any>) {
  switch (action.type) {
    case SHOW_TYPES:
      return {
        ...showState,
        loading: loadingReducer(SHOW_TYPES),
      };
    case getShowsList.fulfilled.toString():
      return {
        ...showState,
        shows: action.payload,
      };
    default:
      return showState;
  }
}
